import * as ActionTypes from "constants/ActionTypes";

const initialState = {
    serviceError: "",
    serviceCode: 200,
    reqStatus: "",
    isLoading: false,
    orderlist: [],
    shoporderlist: [],
    orderdetail: {
        shop: [],
        products: []
    },
    pagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
    },
    pendingPayments: {
        has_pending_payments: false,
        count: 0,
        isLoading: false
    }
};

export default function orderReducer(state = initialState, action) {
    switch (action.type) {

        /* Common Triggers */
        case ActionTypes.USER_GET_SHOP_ORDERLIST_PRODUCTS_START:
        case ActionTypes.USER_GET_SHOP_ORDER_DETAIL_START:
        case ActionTypes.USER_UPDATE_ORDER_STATUS_START:
        case ActionTypes.USER_UPLOAD_PAYMENT_SCREENSHOT_START: {
            return {
                ...state,
                isLoading: true,
                reqStatus: action.type,
                serviceError: "",
            };
        }

        case ActionTypes.USER_CHECK_PENDING_PAYMENTS_START: {
            return {
                ...state,
                pendingPayments: {
                    ...state.pendingPayments,
                    isLoading: true
                },
                reqStatus: action.type,
                serviceError: "",
            };
        }

        /* Common Failures */
        case ActionTypes.USER_GET_SHOP_ORDERLIST_PRODUCTS_FAILURE:
        case ActionTypes.USER_GET_SHOP_ORDER_DETAIL_FAILURE:
        case ActionTypes.USER_UPDATE_ORDER_STATUS_FAILURE: 
        case ActionTypes.USER_UPLOAD_PAYMENT_SCREENSHOT_FAILURE: {
            return {
                ...state,
                isLoading: false,
                reqStatus: action.type,
                serviceError: { ...action.payload },
            };
        }

        case ActionTypes.USER_CHECK_PENDING_PAYMENTS_FAILURE: {
            return {
                ...state,
                pendingPayments: {
                    ...state.pendingPayments,
                    isLoading: false
                },
                reqStatus: action.type,
                serviceError: { ...action.payload },
            };
        }

        case ActionTypes.USER_GET_SHOP_ORDER_DETAIL_SUCCESS:
            return { ...state,
                isLoading: false,
                reqStatus: action.type,
                serviceError: "",
                orderdetail: action.payload.order
            };

        case ActionTypes.USER_GET_SHOP_ORDERLIST_PRODUCTS_SUCCESS:
            return { ...state,
                isLoading: false,
                reqStatus: action.type,
                serviceError: "",
                shoporderlist: action.payload.orders,
                pagination: action.payload.pagination,
            };

        case ActionTypes.USER_UPDATE_ORDER_STATUS_SUCCESS: {
            return {
                ...state,
                isLoading: true,
                reqStatus: action.type,
                serviceError: "",
            };
        }

        case ActionTypes.USER_UPLOAD_PAYMENT_SCREENSHOT_SUCCESS: {
            return {
                ...state,
                isLoading: true,
                reqStatus: action.type,
                serviceError: "",
            };
        }

        case ActionTypes.USER_CHECK_PENDING_PAYMENTS_SUCCESS: {
            return {
                ...state,
                pendingPayments: {
                    has_pending_payments: action.payload.has_pending_payments,
                    count: action.payload.count,
                    isLoading: false
                },
                reqStatus: action.type,
                serviceError: "",
            };
        }

        case ActionTypes.USER_ORDERS_RESET:

            return { ...state,
                isLoading: false,
                orderlist: [],
                shoporderlist: [],
                orderdetail: {
                    shop: [],
                    products: []
                },
            };

        default:
    }
    return state;
}
